<template>
    <div class="commonTopContent">
        <div class="commonTop">
            <div class="topLeft">
                <div class="logo">
                    <img class="logoPicture" src="@/assets/images/logoBlack.png" alt="">
                    <div class="logoWordWrite">增材云业务管理后台</div>
                </div>
                <ul class="menuListClass">
                    <li v-for="(item,index) in navListNew" :class="item.uuid === activeMenu?'active':''" :key="index" @click="toSubmenu(item)">{{item.name}}</li>
                </ul>
            </div>
            <div class="userInfo">
                <img src="../../assets/images/logo.png" alt="">
                <div class="name userInfoName">{{ userInfo.name }}</div>
                <i class="el-icon-arrow-down" @click="userMess = !userMess"></i>
            </div>
        </div>
        <div class="commonBottom" :style="$store.state.hasSubMenu?'padding-left:220px':'padding-left:32px'">
            <div class="menuName">
                当前页面:
                <span class="menuActiveParentName">{{parentMenuName}}&nbsp;&nbsp;|&nbsp;&nbsp;</span>
                <span class="menuActiveName">{{$route.meta.title}} </span>
            </div>
            <!--<el-button type="text">
                <i class="iconfont icon-tuichu"></i>
                <span>退出登录</span>
            </el-button>-->
        </div>
        <!-- 用户弹窗 -->
        <div v-show="userMess" @click="closeMsg" class="userMessageBox">
            <div class="userMessage flex">
                <img class="logoPicture" :src="userInfo.headUrl" alt="" v-if="userInfo.headUrl!=null">
                <img class="logoPicture" src="@/assets/images/logo.png" alt="" v-else>
                <div class="userMes">
                    <h4>
                        {{ userInfo.name }}
                    </h4>
                    <div class="userMesBox flex">
                        <div class="userMesNames flex">
                            <p v-if="userInfo.identity == 'ADMINISTRATOR'">
                                管理员
                            </p>
                            <p v-if="userInfo.identity == 'ENTERPRISE'">
                                企业认证
                            </p>
                            <p v-if="userInfo.identity == 'STAFF'">
                                企业成员
                            </p>
                            <p v-if="userInfo.identity == 'PERSONAL'">
                                个人实名认证
                            </p>
                            <p v-if="userInfo.identity == 'ANONYMOUS'">
                                游客
                            </p>
                        </div>
                        <p class="noUser" @click="getNoUser">退出登录</p>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { getNewcurrent,getMenuList } from '../../utils/interface'
export default {
    name: "common_top",
    data() {
        return {
            activeMenu: '4028e8a47df9fe6b017dfaaed65d0023',
            navListNew: [],
            parentMenuName: '',
            userMess: false,
            userInfo:"",
        }
    },
    created(){
        // console.log('12===', this.$route.path);
        /*this.activeMenu = sessionStorage.getItem('parentMenuId')?sessionStorage.getItem('parentMenuId'):'0'
        let parentMenu = this.navList.filter(item=> item.id ===  this.activeMenu)
        this.parentMenuName = parentMenu[0].name
        this.$store.state.hasSubMenu = parentMenu[0].children?true:false;*/
        getNewcurrent().then((res)=>{
           this.userInfo = res;

        });
        getMenuList().then(res=>{
            window.sessionStorage.setItem('menuList', JSON.stringify(res || []));
            this.navListNew = JSON.parse(window.sessionStorage.getItem('menuList') || '[]')
            this.findPath(this.navListNew)

        })
    },
    mounted() {
        // 注册事件
        this.$bus.$on('navActive', (msg)=>{
            this.activeMenu = msg.uuid
            this.toSubmenu(msg)
        })
    },
    watch:{
        '$route.path':{
            handler(){
                this.findPath(this.navListNew)
            },
            immediate: true
        },
    },
    methods: {
        // 递归寻找path
        findPath(data){
            data.forEach(item => {
                if (item.children&&item.children.length!=0) {
                  this.findPath(item.children)
                }else if(this.$route.path == item.path){
                    // console.log('找到了', item);
                    // console.log('找到了', item.parentUuid);
                    // this.activeMenu = item.uuid
                    if (item.parentUuid != '') {
                        // console.log('进入找父级', );
                        this.findparentId(item.parentUuid, this.navListNew)

                    }else{
                        // console.log('没有子级', );
                        this.activeMenu = item.uuid
                        this.resetSetItem('parentMenuId',item.uuid);
                        window.sessionStorage.setItem('activeMenuSess',item.uuid)
                    }
                }
        });

        },
        // 寻找最厅层的父级uuid
        findparentId(parentUuid, data){
            data.forEach(item=>{
                if (item.uuid == parentUuid ) {
                    // console.log('父层uuid', item.uuid);
                    if (item.parentUuid!= '') {
                        // console.log('找到父级uuid， 但是还有父级', );
                        this.findparentId(item.parentUuid, this.navListNew)
                    }else{
                        // console.log('找到厅层了',item.uuid );
                        this.activeMenu = item.uuid
                        this.resetSetItem('parentMenuId',item.uuid);
                        window.sessionStorage.setItem('activeMenuSess',item.uuid)
                    }
                } else  if (item.children&&item.children.length!=0 ){
                    // console.log('没找到uuid，继续找', );
                    this.findparentId(parentUuid,item.children)
                }

            })
        },
        //   用户弹窗关闭
        closeMsg(event) {
            var btn = document.querySelector(".userMessage");
            if (btn) {
                if (!btn.contains(event.target)) {
                    this.userMess = false;
                }
            }
        },
        // 点击展开二级菜单
        toSubmenu(val){
            window.sessionStorage.setItem('activeMenuSess',val.uuid)
            this.activeMenu = val.uuid;
            this.parentMenuName = val.name;
            this.resetSetItem('parentMenuId',val.uuid);
            if(!val.children){
                this.$router.push(val.url);
                this.$store.commit('updateMenuActiveId', val.uuid);
                this.$store.commit('upDateMenuActiveName', val.name);
                this.$store.commit('upDateHasSubMenu', false)
            } else {
                this.$store.commit('upDateHasSubMenu', true);
                this.getSubmenu(val.children[0])
              /*  if(!val.children[0].children){
                    this.$router.push(val.children[0].url)
                    this.$store.commit('updateMenuActiveId', val.children[0].id)
                    this.$store.commit('upDateMenuActiveName', val.children[0].name)
                } else {
                    this.$router.push(val.children[0].children[0].url)
                    this.$store.commit('updateMenuActiveId', val.children[0].children[0].id)
                    this.$store.commit('upDateMenuActiveName', val.children[0].children[0].name)
                }*/
            }
        },
        // 获取子级路由
        getSubmenu(val){
            if(!val.children){
                this.$router.push(val.url);
                this.$store.commit('updateMenuActiveId', val.uuid);
                this.$store.commit('upDateMenuActiveName', val.name)
            } else {
                this.getSubmenu(val.children[0])
            }
        },
        // 注销用户
        getNoUser() {
            // 取消菜单
            sessionStorage.removeItem('parentMenuId');
            this.$router.push("/");
        },
    }
}
</script>

<style scoped lang="less">
    .commonTopContent{
        .commonTop {
            height: 50px;
            width: 100%;
            position: fixed;
            padding: 14px 32px;
            background: #006dec;
            left: 0;
            top: 0;
            display: flex;
            align-items: center;
            justify-content: space-between;
            z-index: 999;
            color: #fff;
            .userInfo {
                display: flex;
                align-items: center;
                img{
                    width: 24px;
                    height: 24px;
                    border-radius: 50%;
                    margin-right: 5px;
                }
                .userInfoName {
                    white-space: nowrap;
                }
            }
            .topLeft{
                display: flex;
                width: 100%;
                .logo{
                    display: flex;
                    align-items: center;
                    img{
                        display: block;
                    }
                    .logoPicture{
                        // height: 30px;
                        width: 30px;
                    }
                    .logoWordWrite{
                        font-size: 18px;
                        font-weight: 700;
                        padding-left: 10px;
                    }
                }
                .menuListClass{
                    display: flex;
                    padding-left: 30px;
                    line-height: 50px;
                    justify-content: space-around;
                    width: 80%;
                    li{
                        cursor: pointer;
                        &:hover{
                            font-weight: 700;
                        }
                        &.active{
                            font-weight: 700;
                            font-size: 20px;
                        }
                    }
                }
            }
        }
        .commonBottom{
            height: 48px;
            width: 100%;
            position: fixed;
            padding: 14px 32px 14px 220px;
            left: 0;
            top: 50px;
            display: flex;
            align-items: center;
            justify-content: space-between;
            .menuName{
                font-size: 13px;
                .menuActiveParentName{
                    color: #7F7F7F;
                }
                .menuActiveName{
                    color: #526ecc;
                }
            }
            button{
                color: #333;
                &:hover{
                    color: #81d3f8;
                }
            }
        }
    }

    // 用户弹窗
    .userMessageBox {
        position: fixed;
        width: 100%;
        z-index: 4001;
        height: 100%;
        top: 0;
        right: 0;

        .userMessage {
            position: absolute;
            top: 40px;
            right: 24px;
            background: #fff;
            box-shadow: 0px 3px 6px 2px #c9c9c95c;
            box-sizing: border-box;
            border-radius: 10px;
            padding: 20px;
            display: flex;

            img {
                width: 70px;
                height: 70px;
                border-radius: 50%;
                margin-right: 16px;
            }

            .userMes {
                // width: 100%;
                h4 {
                    font-size: 16px;
                    margin-bottom: 25px;

                    &:hover {
                        color: #157efb;
                    }
                }

                .userMesBox {
                    align-items: center;
                    white-space: normal;
                    justify-content: space-between;
                    display: flex;

                    white-space: nowrap;

                    p {
                        margin: 0;
                        white-space: nowrap;
                        font-size: 14px;
                    }

                    .userMesNames {
                        margin-right: 42px;

                        p {
                            padding: 2px 14px;
                            border-radius: 20px;
                            cursor: default;
                            white-space: nowrap;
                        }

                        p:nth-of-type(1) {
                            background: #05930a25;
                            color: #05930a;
                            margin-right: 10px;
                        }

                    }
                }
            }

            .noUser {
                cursor: pointer;
                border: none;
                color: #ff9100;
                font-size: 16px;
            }

            .noUser:hover {
                color: #d01919;
            }
        }
    }
</style>



// WEBPACK FOOTER //
// src/views/layout/common_top.vue